import React from 'react'
import Loadable from 'react-loadable'

import Spin from '@/component/spin'

const dynamicWrapper = (Component) => {
  return Loadable({
    loader: Component,
    loading: Spin.Route,
    delay: 100
  })
}

export const routerConfig = {
  '/': {
    name: '首页',
    component: dynamicWrapper(() => import('@/page/index'))
  },
  '/rank-near': {
    name: '附近排名',
    component: dynamicWrapper(() => import('@/page/rank-near'))
  },
  '/rank-national': {
    name: '全国排名',
    component: dynamicWrapper(() => import('@/page/rank-national'))
  },
  '/detail': {
    name: '详情',
    component: dynamicWrapper(() => import('@/page/detail'))
  }
}
